import { render, staticRenderFns } from "./EventTemplates.vue?vue&type=template&id=86478432&scoped=true&"
import script from "./EventTemplates.vue?vue&type=script&lang=js&"
export * from "./EventTemplates.vue?vue&type=script&lang=js&"
import style0 from "./EventTemplates.vue?vue&type=style&index=0&id=86478432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86478432",
  null
  
)

export default component.exports